import { s as p, x as r, i as s, r as o, e as f } from "../../query-assigned-elements-96a4d233.mjs";
import "../../components/page-footer/index.js";
import "../../index-19a5caf5.mjs";
const h = `:host{--font-regular: "Circular Std Medium", Helvetica, Arial, sans-serif;--font-regular-italic: "Circular Std Medium Italic", Helvetica, Arial, sans-serif;--font-thin: "Circular Std Book", Helvetica, Arial, sans-serif;--font-thin-italic: "Circular Std Book Italic", Helvetica, Arial, sans-serif;--font-bold: "Circular Std Bold", Helvetica, Arial, sans-serif;--font-bold-italic: "Circular Std Bold Italic", Helvetica, Arial, sans-serif;font-size:16px;--fs-xxl: 40px;--fs-xl: 35px;--fs-l: 25px;--fs-m: 19px;--fs-s: 16px;--fs-xs: 14px;--padding-inline: 2em;--padding-block: 2em;--max-width-main-content: 500px;--max-width-menu: 350px;--height-top-menu: 5em;--width-side-menu: 22em;--max-width-search-menu: 550px}@media screen and (max-width: 390px){:host{--fs-xxl: 37px;--fs-xl: 30px;--fs-l: 25px;--fs-m: 18px;--fs-s: 16px;--fs-xs: 14px}}@media screen and (max-width: 1300px){:host{--padding-inline: 1.5em;--padding-block: 1.5em}}@media screen and (max-width: 500px){:host{--padding-inline: 1em;--padding-block: 1.5em}}h1,h2,h3,h4,h5{font-family:var(--font-bold);color:#31273e;margin-block:.5em}h1{font-size:var(--fs-xxl);line-height:1.2}h2{font-size:var(--fs-xl)}h3{font-size:var(--fs-l)}h4{font-size:var(--fs-m)}h5{font-size:var(--fs-s)}p,span,address{font-family:var(--font-thin);font-size:var(--fs-s);color:#919191;line-height:initial;padding:initial;line-height:1.5}a{font-size:1em;color:#00a3ff;text-decoration:underline;cursor:pointer}div{font-family:var(--font-thin);color:#919191;line-height:1}button{display:flex;align-items:center;gap:1.2em;padding:.6em 1.5em;border-radius:1.8em;font-size:1em;cursor:pointer;font-family:var(--font-regular);transition:all .2s ease-in-out;border:none}.gray-box{background-color:#f6f6f6;padding:1.5em;border-radius:.5em;border:1px solid #e0e0e0;text-align:center}.page-container{display:flex;flex-direction:column;height:100%;min-height:100svh;overflow-x:hidden;overflow-y:auto;margin:0;padding:0}.page-container .page-content{display:flex;flex-direction:column;align-items:center;justify-content:center;overflow:hidden;gap:3em;font-size:.9em;justify-self:center;align-self:center;flex:1;padding:var(--padding-block) var(--padding-inline)}.page-container .page-content h2{margin:0;text-align:center}.page-container .page-massage{color:#919191;background-color:#f5f5f5;max-width:var(--max-width-main-content);border-radius:1em;padding:1em var(--padding-inline);height:max-content}.page-container .page-massage>*{text-align:center}@media screen and (max-width: 500px){.page-container .page-massage{border-radius:0;max-width:initial;margin-inline:calc(var(--padding-inline) * -1)}}.page-container .page-illustration{width:100%;max-width:var(--max-width-main-content)}.page-container .page-illustration svg{width:100%;max-height:350px}@keyframes move{0%{transform:translateY(7%)}to{transform:translateY(0)}}#hand{animation:move .6s ease-in-out infinite alternate}
`;
var c = Object.defineProperty, m = Object.getOwnPropertyDescriptor, g = (n, i, t, a) => {
  for (var C = a > 1 ? void 0 : a ? m(i, t) : i, e = n.length - 1, l; e >= 0; e--)
    (l = n[e]) && (C = (a ? l(i, t, C) : l(C)) || C);
  return a && C && c(i, t, C), C;
};
let d = class extends p {
  constructor() {
    super(...arguments), this.illustrationSVG = r`
      <svg viewBox="0 0 389 190" fill="none" xmlns="http://www.w3.org/2000/svg">
         <g id="hand">
            <path
               d="M316.25 87.38C316.25 84.299 318.156 81.804 320.511 81.804H324.049C326.403 81.804 328.31 84.299 328.31 87.38C328.31 89.199 327.611 91.962 325.511 92.721C324.058 93.246 321.086 93.976 319.977 90.757L316.277 90.676C316.305 88.804 316.25 90.342 316.25 87.38Z"
               fill="#BF994D"
            />
            <path
               d="M324.326 80.032C324.326 80.032 319.929 83.928 324.028 93.011C329.769 93.211 351.63 93.923 351.63 93.923L349.216 72L324.326 80.032Z"
               fill="#994D26"
            />
            <path d="M323.87 94.234H320.692V116.062H323.87V94.234Z" fill="#717171" />
            <path
               d="M344.838 94.234C344.838 95.349 343.935 96.254 342.82 96.254H311.019C309.904 96.254 309 95.35 309 94.234C309 93.121 309.903 92.216 311.019 92.216H342.821C343.935 92.216 344.838 93.12 344.838 94.234Z"
               fill="#331A00"
            />
            <path
               d="M311.81 88.92C311.81 85.839 313.716 83.344 316.071 83.344H319.609C321.963 83.344 323.87 85.839 323.87 88.92C323.87 90.739 323.171 93.502 321.071 94.261C319.618 94.786 316.646 95.516 315.537 92.297L311.837 92.216C311.865 90.344 311.81 91.882 311.81 88.92Z"
               fill="#FFCC66"
            />
            <path
               d="M321.368 81.281C321.368 81.281 316.971 85.177 321.07 94.26C326.811 94.46 348.672 95.172 348.672 95.172L348.894 81.373L321.368 81.281Z"
               fill="#CC6633"
            />
            <path
               opacity="0.6"
               d="M311.019 96.254C312.134 96.254 313.038 95.3501 313.038 94.235C313.038 93.1199 312.134 92.216 311.019 92.216C309.904 92.216 309 93.1199 309 94.235C309 95.3501 309.904 96.254 311.019 96.254Z"
               fill="#717171"
            />
         </g>
         <path
            d="M319.9 170.9C327.411 170.9 333.5 170.184 333.5 169.3C333.5 168.416 327.411 167.7 319.9 167.7C312.389 167.7 306.3 168.416 306.3 169.3C306.3 170.184 312.389 170.9 319.9 170.9Z"
            fill="#CECECE"
         />
         <path
            d="M332.5 167.6C332.5 168.4 331.8 169.1 331 169.1H313C312.2 169.1 311.5 168.4 311.5 167.6C311.5 166.8 312.2 166.1 313 166.1H331C331.8 166.2 332.5 166.8 332.5 167.6Z"
            fill="#331A00"
         />
         <path d="M329.1 114.7H316.6V167.6H329.1V114.7Z" fill="#331A00" />
         <path
            d="M348.8 189.2C370.726 189.2 388.5 187.051 388.5 184.4C388.5 181.749 370.726 179.6 348.8 179.6C326.874 179.6 309.1 181.749 309.1 184.4C309.1 187.051 326.874 189.2 348.8 189.2Z"
            fill="#CECECE"
         />
         <path
            d="M230.3 140.4C230.3 141.3 245.6 147.8 230.3 147.8C208.3 147.8 157.3 147.1 125.4 147.1C68.3998 147.1 22.0999 145.4 22.0999 143.3C22.0999 141.2 68.2999 139.5 125.4 139.5C182.4 139.4 230.3 138.2 230.3 140.4Z"
            fill="#CECECE"
         />
         <path
            d="M237.9 147.7C258.555 147.7 275.3 145.685 275.3 143.2C275.3 140.715 258.555 138.7 237.9 138.7C217.245 138.7 200.5 140.715 200.5 143.2C200.5 145.685 217.245 147.7 237.9 147.7Z"
            fill="#CECECE"
         />
         <path
            d="M320.4 183.2C320.4 183.2 319.7 175.7 329.6 175.5C339.5 175.3 342.5 175.9 343.6 183.2C336.9 183.2 320.4 183.2 320.4 183.2Z"
            fill="#4D2F12"
         />
         <path
            d="M344 184C344 184.6 343.5 185.1 342.9 185.1H320.8C320.2 185.1 319.7 184.6 319.7 184C319.7 183.4 320.2 182.9 320.8 182.9H343C343.6 182.9 344 183.4 344 184Z"
            fill="#996666"
         />
         <path
            d="M350 183.6C350 183.6 349.3 176.1 359.2 175.9C369.1 175.6 372.1 176.3 373.2 183.6C366.6 183.6 350 183.6 350 183.6Z"
            fill="#4D2F12"
         />
         <path
            d="M373.7 184.4C373.7 185 373.2 185.5 372.6 185.5H350.5C349.9 185.5 349.4 185 349.4 184.4C349.4 183.8 349.9 183.3 350.5 183.3H372.6C373.2 183.3 373.7 183.8 373.7 184.4Z"
            fill="#996666"
         />
         <path
            d="M287.8 123.9C287.8 123.9 295.1 75.2 277.4 67.8C269.2 64.4 257.2 63.7 244.7 63.4C235.3 46.5 226.3 31.1 226.3 31.1C226.3 31.1 221.6 21 213.8 20.8C207.8 20.7 156.7 18.3 135.4 17.9C122.2 17.6 117 24.9 117 24.9L81.9 58.8L32.3 59.8C32.3 59.8 7.60002 60.4 7.30002 79.4C7.10002 90.7 6.60002 100 6.60002 100C6.60002 100 5.80003 118.1 29.9 118.7C34.8 115.8 52.9 106.8 76.3 107.3C81.5 107.4 88.8 115.7 93.4 120.1C128.1 120.8 170.1 121.7 206.8 122.5C214 114.5 220.4 117.5 227.4 117.7C261.7 118.2 287.8 123.9 287.8 123.9Z"
            fill="#583643"
         />
         <path
            d="M244.8 118.3C244.8 121.4 255.1 115.5 266.2 123.7L287.5 124C290.6 124 293.1 121.5 293.1 118.4V111.8C293.1 108.7 290.6 106.2 287.5 106.2H250.4C247.3 106.2 244.8 108.7 244.8 111.8V118.3Z"
            fill="#4D4D4D"
         />
         <path
            d="M40.7 109.5C40.7 114.9 34.9 115.1 29.9 118.6C29.9 118.6 24.3 118.5 3.39995 117.9L0.199951 110.2C0.199951 104.8 0.599951 100.5 5.99995 100.4L64.3 103.6C69.7 103.6 74.1 107.9 74.2 113.3L40.7 109.5Z"
            fill="#4D4D4D"
         />
         <path
            d="M35.9 106.7L36.1 102L6 100.4C2.3 100.4 1 102.4 0.5 105.4L35.9 106.7Z"
            fill="#717171"
         />
         <path
            d="M93.8999 111.2C92.4999 93.9 81.1999 81.4 59.7999 82.8C42.9999 84 29.3999 96.4 29.3999 113.2C29.3999 115 29.5999 116.8 29.8999 118.6C39.3999 113.3 56.0999 112.4 83.2999 113C83.9999 113 91.0999 118.5 93.3999 119.9C93.8999 117.8 94.0999 113.5 93.8999 111.2Z"
            fill="#371F26"
         />
         <path
            d="M287.5 106.1H255.8V110.7H293C292.6 108.1 290.3 106.1 287.5 106.1Z"
            fill="#717171"
         />
         <path
            d="M267 117C267 100.2 253.4 86.6 236.6 86.6C219.8 86.6 206.2 100.2 206.2 117C206.2 118.8 206.4 120.5 206.7 122.3C219.5 114.5 230.7 103.5 266.2 123.7C266.7 121.5 267 119.3 267 117Z"
            fill="#371F26"
         />
         <path
            d="M61.6999 144.2C77.6057 144.2 90.4999 131.306 90.4999 115.4C90.4999 99.4942 77.6057 86.6 61.6999 86.6C45.7941 86.6 32.8999 99.4942 32.8999 115.4C32.8999 131.306 45.7941 144.2 61.6999 144.2Z"
            fill="#291D11"
         />
         <path
            d="M61.6999 136.4C73.2979 136.4 82.6999 126.998 82.6999 115.4C82.6999 103.802 73.2979 94.4 61.6999 94.4C50.102 94.4 40.7 103.802 40.7 115.4C40.7 126.998 50.102 136.4 61.6999 136.4Z"
            fill="#C6C6C6"
         />
         <path
            d="M61.7 135.7C50.4 135.7 41.3 126.8 40.8 115.7C40.8 116 40.8 116.3 40.8 116.7C40.8 128.3 50.2001 137.7 61.8001 137.7C73.4001 137.7 82.8001 128.3 82.8001 116.7C82.8001 116.4 82.8001 116 82.8001 115.7C82.1001 126.8 72.9 135.7 61.7 135.7Z"
            fill="#595651"
         />
         <path
            d="M61.7 125.9C66.781 125.9 70.9 121.781 70.9 116.7C70.9 111.619 66.781 107.5 61.7 107.5C56.619 107.5 52.5 111.619 52.5 116.7C52.5 121.781 56.619 125.9 61.7 125.9Z"
            fill="#8E8E8E"
         />
         <path
            d="M61.7 123.9C66.781 123.9 70.9 119.781 70.9 114.7C70.9 109.619 66.781 105.5 61.7 105.5C56.619 105.5 52.5 109.619 52.5 114.7C52.5 119.781 56.619 123.9 61.7 123.9Z"
            fill="#AFAFAF"
         />
         <path
            d="M61.7 107.5C66.4 107.5 70.3 111.1 70.8 115.7C70.8 115.4 70.9 115 70.9 114.7C70.9 109.6 66.8 105.5 61.7 105.5C56.6 105.5 52.5 109.6 52.5 114.7C52.5 115 52.5 115.4 52.6 115.7C53.1 111.1 57 107.5 61.7 107.5Z"
            fill="#E8E8E8"
         />
         <path
            d="M262.6 119C262.6 125.9 258.2 131.5 265.3 139.4C270.2 145.7 246.8 143 237.7 143C228.4 143 204.4 145.2 211 139.7C220.7 131.6 212.6 125.1 212.6 118.4C212.6 102.5 221.8 92.7 237.7 92.7C253.6 92.6 262.6 103.1 262.6 119Z"
            fill="#291D11"
         />
         <path
            d="M237.7 94.4C253.3 94.4 262.2 104.5 262.5 119.9C262.5 119.6 262.5 119.3 262.5 119.1C262.5 103.2 253.5 92.8 237.6 92.8C221.7 92.8 212.5 102.6 212.5 118.5C212.5 118.7 212.5 119 212.5 119.2C213 103.8 222.1 94.4 237.7 94.4Z"
            fill="#595651"
         />
         <path
            d="M237.7 139.4C249.298 139.4 258.7 129.998 258.7 118.4C258.7 106.802 249.298 97.4 237.7 97.4C226.102 97.4 216.7 106.802 216.7 118.4C216.7 129.998 226.102 139.4 237.7 139.4Z"
            fill="#C6C6C6"
         />
         <path
            d="M237.7 138.4C226.4 138.4 217.3 129.5 216.8 118.4C216.8 118.7 216.8 119.1 216.8 119.4C216.8 131 226.2 140.4 237.8 140.4C249.4 140.4 258.8 131 258.8 119.4C258.8 119.1 258.8 118.7 258.7 118.4C258.1 129.5 248.9 138.4 237.7 138.4Z"
            fill="#595651"
         />
         <path
            opacity="0.4"
            d="M15.3 64.7L284.3 75.3C282.5 71.8 280.2 69.1 277 67.8C273.1 66.2 268.3 65.1 263 64.5L254.2 63.7C251 63.5 247.7 63.4 244.3 63.3C244.2 63.1 244.1 63 244 62.8L81.5 58.7L32.5 59.7C32.5 59.7 23.9 59.5 15.3 64.7Z"
            fill="#795E69"
         />
         <path
            d="M13.7 63.8H27.7C27.7 63.8 32.5 63.2 32.4 68.4C32.3 73.7 31.9 75.6 28.4 75.6C24.9 75.6 7.90003 74.6 7.90003 74.6C7.90003 74.6 6.20003 65.4 13.7 63.8Z"
            fill="#FF9966"
         />
         <path
            d="M284.3 74.5H268.4L270.3 82.1H287.1C287.2 82.1 285.5 76.4 284.3 74.5Z"
            fill="#990033"
         />
         <path
            d="M135.7 54.1C135.7 54.1 136.8 40.8 137 32.7C137.2 24.6 131.9 24.6 131.9 24.6L117.8 24.1C117.4 24.6 117.1 24.9 117.1 24.9L82 58.8C82 58.8 113.7 59.7 128.8 59.8C135.4 59.7 135.7 54.1 135.7 54.1Z"
            fill="#999999"
         />
         <path
            d="M192.8 57.5C192.8 59.6 191 61.3 188.9 61.3L145.4 60.8C143.3 60.8 141.6 58.9999 141.6 56.8999L141.9 30C141.9 27.9 143.7 26.2 145.8 26.2L189.3 26.7C191.4 26.7 193.1 28.5 193.1 30.6L192.8 57.5Z"
            fill="#999999"
         />
         <path
            d="M204.8 62.1C215.1 62.2 233.7 62.6 244.4 62.8C235.1 46.1 226.3 31 226.3 31C226.3 31 225.5 29.3 224.1 27.3L204.3 26.7C204.3 26.7 199.3 25.9 199.3 31.1C199.3 39.2 199.2 56.9 199.2 56.9C199.2 56.9 198.4 62 204.8 62.1Z"
            fill="#999999"
         />
         <path
            d="M194.2 71.6C194.2 72.6 193.5 73.4 192.7 73.4H179.5C178.7 73.4 178 72.6 178 71.6C178 70.6 178.7 69.8 179.5 69.8H192.7C193.5 69.8 194.2 70.6 194.2 71.6Z"
            fill="#422932"
         />
         <path
            d="M194.2 70.5C194.2 71.5 193.5 72.3 192.7 72.3H179.5C178.7 72.3 178 71.5 178 70.5C178 69.5 178.7 68.7 179.5 68.7H192.7C193.5 68.7 194.2 69.5 194.2 70.5Z"
            fill="#795E69"
         />
         <path
            d="M61.7 88.7C77.3 88.7 89.9 101.1 90.5 116.5C90.5 116.2 90.6 115.8 90.6 115.5C90.6 99.6 77.7 86.7 61.8 86.7C45.9 86.7 33 99.6 33 115.5C33 115.8 33 116.2 33.1 116.5C33.5 101 46.1 88.7 61.7 88.7Z"
            fill="#595651"
         />
         <path
            d="M7.39985 78.1H14.3999C14.3999 78.1 19.7999 77.6 19.4999 85.2C19.1999 92.7 19.4999 101.1 19.4999 101.1L6.59985 100.4L7.39985 78.1Z"
            fill="#371F26"
         />
         <path
            d="M69 69.7C69 70.7 68.2 71.6 67.1 71.6H62.4C61.4 71.6 60.5 70.8 60.5 69.7C60.5 68.7 61.3 67.8 62.4 67.8H67.1C68.2 67.8 69 68.7 69 69.7Z"
            fill="#FFCC33"
         />
         <path
            opacity="0.49"
            d="M131.7 66.6C132 71.5 132.1 76.3 132.3 81.2L132.5 88.5L132.7 95.8V95.9C132.5 97.9 132.9 100.1 134 101.8C135.1 103.5 137 104.8 139.2 105.5C141.4 106.2 143.8 106.4 146.3 106.5L154 106.6H169.4L184.8 106.5H184.9H185.1C185.9 106.6 187 106.6 187.9 106.5C188.8 106.3 189.8 106.1 190.6 105.6C192.3 104.8 193.7 103.4 194.7 101.9C196.8 98.7 197.5 94.9 197.9 91.1C198.2 87.2 198.5 83.3 198.8 79.5C199.2 75.6 199.5 71.7 200 67.9C199.8 75.7 199.8 83.5 199.7 91.3C199.5 95.2 198.9 99.3 196.7 103C195.6 104.8 193.9 106.5 191.8 107.7C190.7 108.3 189.5 108.7 188.3 108.9C187 109.1 185.9 109.2 184.5 109H184.8C179.6 109.2 174.5 109.2 169.3 109.3C164.1 109.4 159 109.3 153.8 109.3C151.2 109.3 148.6 109.2 146 109.1C143.4 109 140.6 108.8 138 107.8C135.4 106.9 133 105.2 131.6 103C130.3 100.7 129.9 98.3 130.3 95.8V96L130.5 88.7L130.7 81.4C131.3 76.3 131.4 71.5 131.7 66.6Z"
            fill="#371F26"
         />
         <path
            d="M93.9663 113.984L93.9409 115.384L206.818 117.43L206.844 116.03L93.9663 113.984Z"
            fill="#371F26"
         />
         <path
            d="M237.9 127.8C242.981 127.8 247.1 123.681 247.1 118.6C247.1 113.519 242.981 109.4 237.9 109.4C232.819 109.4 228.7 113.519 228.7 118.6C228.7 123.681 232.819 127.8 237.9 127.8Z"
            fill="#8E8E8E"
         />
         <path
            d="M237.9 125.7C242.981 125.7 247.1 121.581 247.1 116.5C247.1 111.419 242.981 107.3 237.9 107.3C232.819 107.3 228.7 111.419 228.7 116.5C228.7 121.581 232.819 125.7 237.9 125.7Z"
            fill="#AFAFAF"
         />
         <path
            d="M237.9 109.4C242.6 109.4 246.5 113 247 117.6C247 117.3 247.1 116.9 247.1 116.6C247.1 111.5 243 107.4 237.9 107.4C232.8 107.4 228.7 111.5 228.7 116.6C228.7 116.9 228.7 117.3 228.8 117.6C229.2 113 233.1 109.4 237.9 109.4Z"
            fill="#E8E8E8"
         />
         <path
            d="M316.6 164.7C304.7 164.7 301 159.3 299.2 154.7C298.1 151.9 297.1 149.5 294.2 148.4C286.3 145.6 278.8 148.4 278.1 149.6C278.2 150.6 277.9 151.5 277.2 152.3C274.8 154.7 268.2 155.1 256.9 153.6C251.6 152.9 248 150.8 246.2 147.5C242.7 141.1 247 132 248.4 129C248.5 128.7 248.6 128.5 248.7 128.3C249 127.6 249.6 127.1 250.3 126.9C252.3 126.4 254.9 128.4 255.4 128.8L254.1 130.4C253.2 129.7 251.5 128.7 250.8 128.9C250.7 128.9 250.7 128.9 250.6 129.1C250.5 129.3 250.4 129.5 250.3 129.8C249 132.6 245 141 248 146.5C249.5 149.2 252.6 150.9 257.2 151.6C270.9 153.5 274.7 152 275.8 150.9C276.1 150.6 276.2 150.3 276.2 149.9C276.1 149.4 276.2 148.7 277.2 147.9C279.8 145.7 287.7 144 295 146.6C298.8 148 300.1 151 301.2 154C303 158.6 306.2 163 316.7 163V164.7H316.6V164.7Z"
            fill="#595651"
         />
         <path
            d="M135.4 17.9C128.6 17.8 124 19.6 121 21.4L222.1 25.1C220 22.9 217.2 20.9 213.7 20.8C207.8 20.6 156.6 18.3 135.4 17.9Z"
            fill="#795E69"
         />
         <path
            d="M119.4 48.9H110.9C108.4 48.9 106.4 50.9 106.4 53.4C106.4 53.8 106.5 54.3 106.6 54.7L102.3 59.8H106.1L108 56.8C108.8 57.5 109.8 57.9 110.9 57.9H119.4C121.9 57.9 123.9 55.9 123.9 53.4C123.9 50.9 121.9 48.9 119.4 48.9Z"
            fill="#583643"
         />
         <path
            d="M373 113.1C356.4 113.1 337.7 113.1 325.1 113.1L324.7 82.7L324.4 63.5C324.4 54.1 331.3 49.8 340.3 47.6H360.8C366.6 48.9 372.9 54.8 372.9 64.3L373 113.1Z"
            fill="#CC6633"
         />
         <path
            d="M370.5 23.9C370.5 12.1 360.9 2.5 349.1 2.5C337.3 2.5 327.7 12.1 327.7 23.9C327.7 32.6 332.9 40 340.3 43.4V47.6H357V43.8C364.9 40.6 370.5 32.9 370.5 23.9Z"
            fill="#FFCC66"
         />
         <path
            d="M331.6 14.5C331.6 14.5 327.4 20.7 331.6 26.8C335.8 32.8 346.2 34.7 346.2 34.7C346.2 34.7 344.2 32.3 344.8 30.7C346.4 34.4 349.2 35.4 349.2 35.4C349.2 35.4 361 39.9 366 37.2C371.1 32.8 372 21.3 369 15.9C366.3 11.2 332 11.4 332 11.4L331.6 14.5Z"
            fill="#4D331A"
         />
         <path
            d="M330.2 10.6C330.2 10.6 326.5 10.4 325 14.4C324.2 16.5 325.2 17.4 334.2 15.4C343.3 13.4 348.4 10.7 358.4 11.9C368.4 13.1 364.6 8.89996 364.6 8.89996L330.2 10.6Z"
            fill="#789B0D"
         />
         <path
            d="M343.1 0.299977C343.1 0.299977 375.2 5.29997 376.2 12.7C377.2 20.1 369.4 18.2 369.4 18.2C369.4 18.2 350.2 12.2 337.9 14C325.6 15.8 325.7 13.6 324.8 10.6C323.4 6.29997 324.3 -0.600023 343.1 0.299977Z"
            fill="#9EBC3F"
         />
         <path
            d="M325.1 113.1L324.7 179.4H341.8C341.8 179.4 341.5 132.8 343.5 127.4C348.7 129.7 353.9 127.4 353.9 127.4C353.9 127.4 354.7 130 355 134.4C355.2 138.8 356 179.4 356 179.4L371.8 179.8L373 113.1H325.1Z"
            fill="#2B2744"
         />
      </svg>
   `;
  }
  render() {
    return r`
         <div class="page-container">
            <div class="page-content">
               <div class="page-illustration">${this.illustrationSVG}</div>
               <h2 id="title">An Error has Occurred</h2>
               <span class="page-massage">
                  <p>
                     This is unexpected. If the problem persists, please reach out to our
                     <a href="https://support.rentpost.com">support team</a> for
                     assistance.
                  </p>
               </span>
            </div>
            <page-footer></page-footer>
         </div>
      `;
  }
  static get styles() {
    return s`
         ${o(h)}
      `;
  }
};
d = g([
  f("page-error-exception")
], d);
export {
  d as PageErrorExceptionElement
};
//# sourceMappingURL=index.js.map
